var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconanalyticscalendar = function SvgIconanalyticscalendar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Analytics/icon.analytics.calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Analytics/icon.analytics.calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,7 L28,7 L28,26 C28,27.1045695 27.1045695,28 26,28 L4,28 C2.8954305,28 2,27.1045695 2,26 L2,7 L2,7 Z",
    id: "Rectangle",
    stroke: "#09BE86",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#09BE86",
    x: 5,
    y: 10,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 3.5,
    x2: 7.5,
    y2: 1.5,
    id: "Line",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    y1: 3.5,
    x2: 23.5,
    y2: 1.5,
    id: "Line-Copy",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L27,3 C28.1045695,3 29,3.8954305 29,5 L29,8 L29,8 L1,8 L1,5 C1,3.8954305 1.8954305,3 3,3 Z",
    id: "Rectangle",
    fill: "#09BE86"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconanalyticscalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.analytics.calendar.87652af185ef1feaaa44593b16451f0d.svg";